import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import Button from '../../atoms/Button';
import { H4, Text } from '../../atoms/typography';
import { styled } from '@mui/system';
const ErrorFallbackContainer = styled('div') `
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-basis: 100%;
  padding: 24px;
`;
const ErrorFallback = ({ title, description, actionLabel, action, type = 'unauthorized', }) => {
    const theme = useTheme();
    const iconStyle = {
        height: '60px',
        width: '60px',
        color: theme.palette.grey[400],
    };
    let icon = (_jsx(LockOutlinedIcon, { sx: iconStyle }));
    switch (type) {
        case 'error':
            icon = (_jsx(ErrorOutlineRoundedIcon, { sx: iconStyle }));
            break;
        // Add more variations here if needed
        default:
            break;
    }
    return (_jsxs(ErrorFallbackContainer, { children: [_jsx("div", { children: icon }), _jsx(H4, { children: title }), _jsx(Text, { style: { textAlign: 'center' }, children: description }), (action && actionLabel) ?
                (_jsx(Button, { label: actionLabel, onClick: () => { action(); }, size: "medium", variant: "contained" })) :
                null] }));
};
export default ErrorFallback;
//# sourceMappingURL=index.js.map